import React from 'react';
import { Col, InputNumber, Row, Slider } from 'antd';

declare type TemperatureSliderProps = {
  value: number;
  onChange?: (value) => void;
  disabled?: boolean;
  min?: number;
  max?: number;
};

export const TemperatureSlider: React.FC<TemperatureSliderProps> = ({
  value,
  onChange,
  disabled = false,
  min = 10,
  max = 35
}) => {
  const localOnChange = val => {
    onChange && onChange(val);
  };

  return (
    <Row>
      <Col span={12}>
        <Slider
          min={min}
          max={max}
          onChange={localOnChange}
          value={typeof value === 'number' ? value : 0}
          disabled={disabled}
        />
      </Col>
      <Col span={4}>
        <InputNumber
          style={{ margin: '0 16px' }}
          value={value}
          bordered={false}
          onChange={localOnChange}
          readOnly={disabled}
        />
      </Col>
    </Row>
  );
};
